exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "hr[data-v-68e11c84] {\n  margin: 6rem 0 4rem;\n}\n.post-details[data-v-68e11c84] {\n  margin-bottom: 3rem;\n}", ""]);

// exports
